import { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Home() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    axios.get(`${API}/content`).then((res) => setContent(res.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="home-page" className="font-manrope">
      <Navbar />
      <main>
        <Hero content={content} />
        <Services content={content} />
        <Gallery />
        <About content={content} />
        <Contact content={content} />
      </main>
      <Footer />
    </div>
  );
}
